<template>
  <base-section
    id="keep-in-touch2"
    space="56"
  >
    <v-container style="max-width: 1160px">
      <v-row justify="space-between">
        <v-col
          cols="12"
          md="6"
        >
          <base-info-card
            :title="leftTitle"
            size="text-h5"
            mobile-size="text-h6"
            space="6"
          >
            {{ leftContent }}
          </base-info-card>

          <div
            id="contact-form"
            class="mt-6"
          >
            <base-section-heading
              :title="formTitle"
              size="text-h6"
              mobile-size="text-h5"
              title-tag="h2"
              space="3"
              color="rgba(0,0,0,0.9)"
            />
            <base-contact-form
              :title="formSubtitle"
            />
          </div>
        </v-col>

        <v-col
          cols="12"
          md="6"
        >
          <base-section-heading
            :title="rightTitle"
            size="text-h5"
            mobile-size="text-h5"
            title-tag="h2"
            space="4"
            color="rgba(0,0,0,0.9)"
          />

          <v-row v-if="displayMode === 'image'">
            <v-col
              v-for="(item, index) in displayItems"
              :key="`image-${index}`"
              cols="6"
              class="text-center"
            >
              <div class="contact-card image-mode-card">
                <v-img
                  v-if="item.imageUrl"
                  :src="item.imageUrl"
                  :alt="item.label || 'contact'"
                  max-width="180"
                  class="mx-auto mb-3 contact-image"
                />
                <div
                  v-else
                  class="empty-image-tip"
                >
                  No image uploaded
                </div>
                <div class="qr-label">
                  {{ item.label }}
                </div>
                <div class="qr-caption">
                  {{ item.value }}
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row v-else>
            <v-col
              v-for="(item, index) in displayItems"
              :key="`plain-${index}`"
              cols="12"
              class="text-left"
            >
              <div class="contact-card plain-mode-card">
                <div class="qr-label">
                  {{ item.label }}
                </div>
                <div class="qr-caption">
                  {{ item.value }}
                </div>
                <div
                  v-if="item.text"
                  class="plain-desc"
                >
                  {{ item.text }}
                </div>
              </div>
            </v-col>
          </v-row>

          <div
            v-if="showCompanyContact"
            class="company-contact mt-4"
          >
            <div class="company-contact-item">
              <div class="company-contact-label">
                {{ companyContactContent.addressLabel }}
              </div>
              <div class="company-contact-text">
                <div
                  v-for="line in companyContactContent.addressLines"
                  :key="line"
                >
                  {{ line }}
                </div>
              </div>
            </div>
            <div class="company-contact-item">
              <div class="company-contact-label">
                {{ companyContactContent.phoneLabel }}
              </div>
              <a
                class="company-contact-link"
                :href="`tel:${companyContactContent.phone.replace(/\s/g, '')}`"
              >
                {{ companyContactContent.phone }}
              </a>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'KeepInTouch2',
    data() {
      return {
        moduleConfig: null,
        companyContactEnabled: false,
        companyContact: {
          zh: {
            addressLabel: '公司地址',
            addressLines: [
              '深圳市宝安区航城街道三围社区泰华梧桐工业园大暑（7#）栋8层',
            ],
            phoneLabel: '联系电话',
            phone: '+86 18820291472',
          },
          en: {
            addressLabel: 'Company Address',
            addressLines: [
              "8th Floor, Building 7, Dashu, Taihua Wutong Industrial Park, Sanwei Community, Hangcheng Street, Bao'an District, Shenzhen",
            ],
            phoneLabel: 'Phone',
            phone: '+86 18820291472',
          },
          addressLines: [
            '深圳市宝安区航城街道三围社区泰华梧桐工业园大暑（7#）栋8层',
            "8th Floor, Building 7, Dashu, Taihua Wutong Industrial Park, Sanwei Community, Hangcheng Street, Bao'an District, Shenzhen",
          ],
        },
      }
    },
    computed: {
      isCnRegion() {
        return process.env.VUE_APP_REGION === 'cn'
      },
      isZhLocale() {
        return this.$i18n.locale === 'zh'
      },
      showCompanyContact() {
        return this.isCnRegion && this.companyContactEnabled
      },
      companyContactContent() {
        return this.isZhLocale ? this.companyContact.zh : this.companyContact.en
      },
      leftTitle() {
        return this.moduleConfig?.leftTitle || this.moduleConfig?.title || this.$t('contact.title2')
      },
      leftContent() {
        return this.moduleConfig?.leftContent || this.$t('contact.content1')
      },
      formTitle() {
        return this.moduleConfig?.formTitle || this.$t('contact.form.title')
      },
      formSubtitle() {
        return this.moduleConfig?.formSubtitle || this.$t('contact.form.subtitle')
      },
      rightTitle() {
        return this.moduleConfig?.rightTitle || this.moduleConfig?.subtitle || this.$t('contact.title')
      },
      displayMode() {
        return this.moduleConfig?.displayMode === 'plain' ? 'plain' : 'image'
      },
      displayItems() {
        const items = Array.isArray(this.moduleConfig?.items) ? this.moduleConfig.items : []
        const visibleItems = items
          .filter(item => item && item.show !== false)
          .sort((a, b) => Number(a?.sort || 0) - Number(b?.sort || 0))
        if (!visibleItems.length) {
          return [
            {
              label: this.$t('contact.whatsappLabel'),
              value: this.$t('contact.whatsappValue'),
              imageUrl: '',
              text: '',
            },
            {
              label: this.$t('contact.telegramLabel'),
              value: this.$t('contact.telegramValue'),
              imageUrl: '',
              text: '',
            },
          ]
        }
        return visibleItems.map((item, index) => ({
          label: item.label || (index === 0 ? this.$t('contact.whatsappLabel') : this.$t('contact.telegramLabel')),
          value: item.value || '',
          imageUrl: item.imageUrl || '',
          text: item.text || '',
        }))
      },
    },
    watch: {
      '$i18n.locale'() {
        this.loadContactModule()
      },
    },
    mounted() {
      this.loadContactModule()
      this.loadCompanyContactSetting()
    },
    methods: {
      async loadCompanyContactSetting() {
        if (!this.isCnRegion) {
          this.companyContactEnabled = false
          return
        }

        try {
          const params = await this.$axios({
            method: 'get',
            url: '/public/dict/data',
            params: { dictType: 'sys_params' },
          })
          const companyContactParam = (Array.isArray(params) ? params : [])
            .find(item => String(item?.dictLabel || '').trim() === 'Company_Contact')

          this.companyContactEnabled = companyContactParam?.status !== '1' && String(companyContactParam?.dictValue || '').trim() === '1'
        } catch (error) {
          this.companyContactEnabled = false
        }
      },
      async loadContactModule() {
        try {
          const blocks = await this.$axios({
            method: 'get',
            url: '/public/homepage',
            params: { lang: this.$i18n.locale },
          })
          const block = (blocks || []).find(item => item?.blockKey === 'contact_us' && item?.enabled !== false && item?.content)
          if (!block || !block.content) {
            this.moduleConfig = null
            return
          }
          const parsed = JSON.parse(block.content)
          if (parsed && typeof parsed === 'object') {
            this.moduleConfig = {
              ...parsed,
              title: block.title || parsed.title || '',
              subtitle: parsed.subtitle || '',
            }
          } else {
            this.moduleConfig = null
          }
        } catch (error) {
          this.moduleConfig = null
        }
      },
    },
  }
</script>

<style lang="sass" scoped>
.contact-card
  border: 1px solid #e5e7eb
  border-radius: 12px
  padding: 16px
  background: #fff

.image-mode-card
  min-height: 280px
  display: flex
  flex-direction: column
  justify-content: flex-start

.plain-mode-card
  margin-bottom: 12px

.contact-image
  border-radius: 8px

.empty-image-tip
  height: 180px
  display: flex
  align-items: center
  justify-content: center
  color: #9ca3af
  font-size: 13px
  border: 1px dashed #d1d5db
  border-radius: 8px

.qr-label
  font-size: 18px
  font-weight: 500
  color: rgba(0, 0, 0, 0.9)
  margin-top: 4px

.qr-caption
  font-size: 14px
  color: #6b7280

.plain-desc
  margin-top: 6px
  color: #6b7280
  font-size: 13px

.company-contact
  border: 1px solid #e5e7eb
  border-radius: 12px
  padding: 18px
  background: #fff

.company-contact-item + .company-contact-item
  margin-top: 14px

.company-contact-label
  font-size: 15px
  font-weight: 600
  color: rgba(0, 0, 0, 0.9)
  margin-bottom: 6px

.company-contact-text,
.company-contact-link
  font-size: 14px
  line-height: 1.7
  color: #4b5563

.company-contact-link
  text-decoration: none

  &:hover
    color: var(--v-primary-base)
</style>
